import CasterCommunication from './CasterCommunication.vue'
export default CasterCommunication

export const CASTER_CHAOS_MODE = false    // The streams constantly gets destroyed and recreated
